import * as _4 from 'lodash4';

interface ISchedulerNotification {
  status: 'info' | 'success' | 'error';
  title: string;
  details?: string;
}

export class SchedulerNotificationServant {
  private currentNotification;
  constructor() {}

  private schedulerNotification(notifyArgs: ISchedulerNotification) {
    // @TODO - This is a workaround to get the latest notification element so it can be closed
    return window['HIP']
      ? window['HIP'].fn.notify(notifyArgs).then(() => {
          // @TODO - This is a workaround to get the notification element
          const groupEl = document.querySelector('hi-notification-group');
          const notificationEl = groupEl ? groupEl.children[0] : null;
          this.currentNotification = notificationEl;
        })
      : () => {};
  }

  private isNotificationMessageEmpty(title: string) {
    return _4.isEmpty(title);
  }

  closeCurrentNotification() {
    if (this.currentNotification) {
      this.currentNotification.close();
    }
  }

  showInfoNotification(title: string, details?: string) {
    if (this.isNotificationMessageEmpty(title)) {
      return;
    }
    return this.schedulerNotification({
      status: 'info',
      title,
      details
    });
  }

  showSuccessNotification(title: string, details?: string) {
    if (this.isNotificationMessageEmpty(title)) {
      return;
    }
    return this.schedulerNotification({
      status: 'success',
      title,
      details
    });
  }

  showErrorNotification(title: string, details?: string) {
    if (this.isNotificationMessageEmpty(title)) {
      return;
    }
    return this.schedulerNotification({
      status: 'error',
      title,
      details
    });
  }
}

angular.module('capability-ng-scheduler').service('ngSchedulerNotificationServant', SchedulerNotificationServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/scheduler_notification_servant.ts